import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-def4c430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "visually-hidden" }, "Tijdlijn", -1))
const _hoisted_3 = { class: "timeline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimelineSlider = _resolveComponent("TimelineSlider")!
  const _component_TimelinePeriod = _resolveComponent("TimelinePeriod")!
  const _component_TimelineScrollhint = _resolveComponent("TimelineScrollhint")!

  return (_ctx.timelineData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_TimelineSlider, {
          start: _ctx.start,
          end: _ctx.end,
          periods: _ctx.timelineData.periods,
          "current-period-index": _ctx.currentPeriodIndex,
          onSlide: _ctx.onSlide
        }, null, 8, ["start", "end", "periods", "current-period-index", "onSlide"]),
        _createElementVNode("div", {
          ref: "containerEl",
          class: "timeline-container",
          style: _normalizeStyle({ height: _ctx.containerHeight + 'px' })
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timelineData.periods, (period) => {
              return (_openBlock(), _createBlock(_component_TimelinePeriod, {
                key: period.id,
                period: period
              }, null, 8, ["period"]))
            }), 128))
          ])
        ], 4),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (!_ctx.interacted)
              ? (_openBlock(), _createBlock(_component_TimelineScrollhint, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}